import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ResourcesCreate, ResourcesDelete, ResourcesRefresh, ResourcesRefreshByID, ResourcesRefreshShutters, ResourcesUpdate } from './resources.action';
import { EpicsValuesResource } from 'src/app/components/kenable/ke';
import { Resource, ShutterResource } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { ResourcesService } from 'src/app/components/catalogs/beamline-catalog/resource/resources.service';

export class ResourcesStateModel {
  data: Resource[] = [];
  shutters: ShutterResource[] = [];
  epics: EpicsValuesResource[] = [];
  shuttersLoading = false;
}

@State<ResourcesStateModel>({
  name: 'Resources',
  defaults: {
    data: [],
    shutters: [],
    epics: [],
    shuttersLoading: false
  }
})
@Injectable()
export class ResourcesState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: ResourcesService,

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ResourcesStateModel) {
    return state.data;
  }

  @Action(ResourcesRefresh)
  refresh({ patchState }: StateContext<ResourcesStateModel>) {
    this._service.getAllResources().subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(ResourcesCreate)
  create({ getState, patchState }: StateContext<ResourcesStateModel>, { item }: ResourcesCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(ResourcesUpdate)
  update({ getState, patchState }: StateContext<ResourcesStateModel>, { id, item }: ResourcesUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(ResourcesDelete)
  delete({ getState, patchState }: StateContext<ResourcesStateModel>, { id }: ResourcesDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

  @Action(ResourcesRefreshByID)
  refreshByID({ getState, patchState }: StateContext<ResourcesStateModel>, { id }: ResourcesUpdate) {
    this._service.getResourceById(id).toPromise().then(item => {
      const state = getState();
      const index = state.data.map(x => x.id).indexOf(id);
      if (index >= 0) {
        state.data.splice(index, 1);
      }
      if (item)
        patchState({
          data: [...state.data, item]
        });
    });

  }

  // - shutters

  /**
   * Reloads the shutter catalog and tracks the request with shuttersLoading so consumers
   * (KE Section 0) can show an indicator instead of an empty dropdown while it is in flight.
   * The global loading overlay skips every /Resources call, so this flag is the only visible signal.
   */
  @Action(ResourcesRefreshShutters)
  refreshShutters({ patchState }: StateContext<ResourcesStateModel>) {
    patchState({ shuttersLoading: true });
    this._service.getShutters().subscribe(
      shutters => patchState({ shutters, shuttersLoading: false }),
      error => {
        console.error(error);
        patchState({ shuttersLoading: false });
      }
    );
  }

  @Action(ResourcesRefresh)
  refreshEpicsValues({ patchState }: StateContext<ResourcesStateModel>) {
    this._service.getEpicsValues().subscribe(
      epics => patchState({ epics }),
      error => console.error(error)
    );
  }


}
